import { toCurrency } from "../../../helpers";
import { Td, Table, Th } from "../style";

function Protestos({ consultaJson }) {
  return (
    <>   
      {consultaJson?.report?.protests?.occurrences?.length > 0 &&
        <>
          <Table>
            <tr style={{ backgroundColor: "#e6e6e6", color: "#666263" }}>
              <Th> <h3> Protestos </h3></Th>
            </tr>
          </Table>
          <Table>
            <tr style={{ backgroundColor: "#e6e6e6", color: "#666263" }}>
              <Th>Cartório </Th>
              <Th>Cidade </Th>
              <Th>UF </Th>
              <Th>Data. </Th>
              <Th>Valor </Th>
            </tr>
            {consultaJson?.report?.protests?.occurrences?.map(
              (item) => {
                return (
                  <tr>
                    <Td> {item?.notaryOffice} </Td>
                    <Td> {item?.city} </Td>
                    <Td> {item?.state} </Td>
                    <Td> {item?.date} </Td>
                    <Td> {item?.value && toCurrency(item?.value)} </Td>
                  </tr>
                );
              }
            )}
          </Table>
          <Table>
            <tr>
              <Th style={{ color: "#255391", background: "#dee5eb" }}>
                Total de ocorrências{" "}
                {consultaJson?.report?.protests?.totalOccurrences}. Periodo{" "}
                {
                  consultaJson?.report?.protests?.oldestOccurrenceDate
                }{" "}
                a{" "}
                {
                  consultaJson?.report?.protests?.newestOccurrenceDate
                }{" "}
                valor total das ocorrencias{" "}
                {consultaJson?.report?.protests?.totalValue &&
                  toCurrency(
                    consultaJson?.report?.protests?.totalValue
                  )}{" "}
              </Th>
            </tr>
          </Table>
          <br/>
        </>
      }
    </>
  );
}

export default Protestos;
